import { topicItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            热门话题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            大家都在讨论的黑料话题，点击查看相关视频
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-4xl mx-auto">
          {topicItems.map((item) => (
            <a
              key={item.id}
              href="#media"
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all duration-200 hover:scale-105 cursor-pointer ${item.color}`}
            >
              <span className="whitespace-nowrap">{item.name}</span>
              <span className="text-xs opacity-70 whitespace-nowrap">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}